/**
 * Canonical Remmē™ API endpoint configuration (BUG-3 fix).
 * Single source of truth: reads VITE_REMME_API_URL from env,
 * defaults to the live -production Worker.
 */
export const REMME_API_URL: string = (
  (import.meta.env.VITE_REMME_API_URL as string | undefined) ??
  'https://remme-persona-production.tyrellwilliams-hte.workers.dev'
).replace(/\/+$/, '');
